import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function UsersCtrl ($rootScope, $state, $scope, $translate, workshopAPI) {
  $scope.showUsers = true;

  $scope.filtering = {
    value: ''
  };

  $scope.tableSettings = {
    broadcast: 'filterUsers',
    columns  : [
      {
        field : 'username',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.USERNAME')
        }
      },
      {
        field : 'group_name',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.GROUP')
        }
      },
      {
        field : 'state',
        header: {
          text: $translate.instant('COMPANY_SPACE.USERS.USER')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewUser(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_USERS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/filters/count', [
        $scope.filtering.value || '*',
        'users',
        false
      ])
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'username'
    },
  };

  $scope.getUsers = ( params ) => {
    return workshopAPI.stream('/filters', [
      $scope.filtering.value || '*',
      'users',
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      false
    ]).then(function (users) {
      $scope.users = users;
      $scope.showUsers = !!users.length;
      return users;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewUser(event.row);
  };

  $scope.viewUser = function (event) {
    $state.go('app.user', {
      id: event.id
    });
  };

  $scope.$watch('filtering.value', function (newVal, oldVal) {
    if (newVal !== oldVal) {
      window['filterUsers']();
    }
  });

  $scope.getUsers({
    offset   : 0,
    pageSize : 11,
    field    : 'username',
    direction: 'asc'
  });
}
